export default "__VITE_ASSET__ZBGSlghi__"